module.exports = "<div class=\"row\">\r\n  <div class=\"col-12 nprl\">\r\n    <div class=\"col-sm-2\" style=\"padding-right:0px;\">\r\n      <span class=\"header pull-right\"> היצע שירותים דיגיטליים</span>\r\n    </div>\r\n    <div class=\"col-md-3 pull-left\" style=\"padding-top: 10px;\">\r\n      space\r\n    </div>\r\n    <div class=\"col-md-3 pull-left\" style=\"padding-top: 10px;\">\r\n      חחחחחח\r\n    </div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/blocks/table-header/table-header.component.html
// module id = ./src/app/component/blocks/table-header/table-header.component.html
// module chunks = main